import axios from 'axios';
import React, { useEffect, useState } from 'react'
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useNavigate, useParams } from 'react-router-dom';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import { Avatar } from '@mui/material';
import { useDispatch } from 'react-redux';

const UpdateCompany = () => {
    const dispatch = useDispatch();

    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState({ open: false, message: "", type: "" });

    // Single state object with backend-matching keys
    const [companyData, setCompanyData] = useState({
        company_name: "",
        website: "",
        company_registered_name: "",
        company_location: "",
        city: "",
        company_logo: null,
        company_admin_name: "",
        company_admin_email: "",
        company_admin_phone: "",
        company_registered: "",
        company_description: "",
    });

 
    const getCompany = async () => {
        try {
            const data = new FormData();
            data.append("company_id", params.id);

            const response = await axios.post(ENDPOINT + "get-company.php", data, SecurityHeaders);
            if (response.data.success === true) {
                setCompanyData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching company:", error);
        }
    };

    useEffect(() => {
        getCompany();
    }, [params.id]);


    const handleInputChange = (e) => {
        setCompanyData({
            ...companyData,
            [e.target.name]: e.target.value,
        });
    };

    // Handle File Change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        console.log(file.type);
        if (file && file.type.startsWith("image/")) {
            setCompanyData((prev) => ({ ...prev, company_logo: file }));
        }
    };

    // Update Company
    const updateCompany = async (e) => {
        e.preventDefault();
        dispatch({ type: "LOADING" });
        setLoading(true);

        const data = new FormData();
        data.append("company_id", params.id);
        Object.entries(companyData).forEach(([key, value]) => {
            data.append(key, typeof value === "string" ? value.trim() : value);
        });

        if (companyData.company_logo instanceof File) {
            data.append("company_logo", companyData.company_logo);
        } else {
            data.append("image_url", companyData.company_logo);
        }

        try {
            const res = await axios.post(ENDPOINT + "update-organization.php", data, SecurityHeaders);
            if (res.data.status === "success") {
                dispatch({ type: "DONE_LOADING" });
                setOpen({ open: true, message: "Company updated successfully", type: "success" });
                // Optional: navigate("/companies");
            } else {
                dispatch({ type: "ERROR", payload: "Error occurred while updating company" });
                setOpen({ open: true, message: "Update failed", type: "error" });
            }
        } catch (error) {
            dispatch({ type: "ERROR", payload: error.message });
            setOpen({ open: true, message: error.message, type: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SnackbarToast open={open} handleClose={() => setOpen((prev) => ({ ...prev, open: false }))} />
            <div className="d-flex justify-content-center">
            <div className="container card col-11 col-lg-9 col-sm-12 col-md-10 p-4 shadow rounded-3">
                <h2 className="text-center mb-2">Update Company</h2>

                <form onSubmit={updateCompany}>
                    <div className="mb-3">
                        <label htmlFor="companyLogo" className="form-label">Company Logo</label>
                        <Avatar
                            onClick={() => document.getElementById("fileInput").click()}
                            sx={{ width: 56, height: 56 }}
                            src={
                                companyData.company_logo instanceof File
                                    ? URL.createObjectURL(companyData.company_logo)
                                    : companyData.company_logo
                            }
                        />
                        <input
                            type="file"
                            id="fileInput"
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_name" className="form-label">Company Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="company_name"
                            name="company_name"
                            value={companyData.company_name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="website" className="form-label">Website</label>
                        <input
                            type="text"
                            className="form-control"
                            id="website"
                            name="website"
                            value={companyData.website}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_registered_name" className="form-label">Registered Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="company_registered_name"
                            name="company_registered_name"
                            value={companyData.company_registered_name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_location" className="form-label">Location</label>
                        <input
                            type="text"
                            className="form-control"
                            id="company_location"
                            name="company_location"
                            value={companyData.company_location}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="city" className="form-label">City</label>
                        <input
                            type="text"
                            className="form-control"
                            id="city"
                            name="city"
                            value={companyData.city}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_admin_name" className="form-label">Admin Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="company_admin_name"
                            name="company_admin_name"
                            value={companyData.company_admin_name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_admin_email" className="form-label">Admin Email</label>
                        <input
                            type="email"
                            className="form-control"
                            id="company_admin_email"
                            name="company_admin_email"
                            value={companyData.company_admin_email}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_admin_phone" className="form-label">Admin Phone</label>
                        <input
                            type="text"
                            className="form-control"
                            id="company_admin_phone"
                            name="company_admin_phone"
                            value={companyData.company_admin_phone}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_registered" className="form-label">Registered Status</label>
                        <input
                            type="text"
                            className="form-control"
                            id="company_registered"
                            name="company_registered"
                            value={companyData.company_registered}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="company_description" className="form-label">Description</label>
                        <textarea
                            className="form-control"
                            id="company_description"
                            name="company_description"
                            value={companyData.company_description}
                            onChange={handleInputChange}
                            required
                            rows="3"
                        />
                    </div>

                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Updating..." : "Update Company"}
                    </button>
                </form>
            </div>
        </div>
        </>
    )
}

export default UpdateCompany